"use client";
import {
  ChevronDown as ArrowDownIcon,
  ChevronUp as ArrowUpIcon,
} from "lucide-react";
import useTranslate from "@app/_hooks/useTranslate";

import { useHeaderContext } from "@context/headerContext";
import useOutsideClick from "@hooks/useOutsideClick";
import { Button } from "@components/ngg";
import type { HeaderStoreFragment } from "@server/gql/graphql";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";

import { cn } from "@/lib/utils";

import StoreCard from "./StoreCard";

export default function StorePopup({
  stores,
}: {
  stores: HeaderStoreFragment[];
}) {
  const t = useTranslate();
  useHeaderContext();
  const [open, setOpen] = useState(false);
  const ref = useOutsideClick(() => setOpen(false));
  const pathname = usePathname();

  useEffect(() => setOpen(false), [pathname]);

  if (!stores.length) return null;

  return (
    <div className="relative h-full" ref={ref}>
      <Button
        onClick={() => setOpen(!open)}
        className={cn(
          "relative h-full gap-1 px-2",
          open ? "bg-white text-black" : "bg-inherit",
        )}
        endIcon={
          open ? (
            <ArrowUpIcon strokeWidth={1} className="size-3.5" />
          ) : (
            <ArrowDownIcon strokeWidth={1} className="size-3.5" />
          )
        }
      >
        {t("stores")}
      </Button>

      <div
        className={cn(
          "absolute top-full right-0 z-50 min-w-92 divide-x border-x border-b bg-white",
          open ? "flex" : "hidden",
        )}
      >
        {stores.map((store) => (
          <StoreCard key={store?.sys.id} store={store} />
        ))}
      </div>
    </div>
  );
}
